import { PAP_Create_DashNewStack } from "@mirage/analytics/events/types/create_dash_new_stack";
import { toValidFileName } from "@mirage/service-stacks/service/utils";
import { nonNil } from "@mirage/shared/util/tiny-utils";

import type { StackUpsertId } from "@mirage/service-stacks/service";

export const asStackUpsertId = (
  nsId: string | undefined,
  mutationRequestId: string | null,
): StackUpsertId => {
  return {
    type: nsId ? "nsId" : "requestId",
    id: nsId ? nsId : nonNil(mutationRequestId, "mutationRequestId"),
  };
};

export const newStackPapEvent = (
  nsId: string | undefined,
  sessionId: string | undefined,
  numberOfLinks: number = 0,
) =>
  PAP_Create_DashNewStack({
    isOwner: true,
    isShared: false,
    stackId: nsId,
    numberOfLinks,
    createStackSessionId: sessionId,
    featureLine: "stacks",
    actionSurfaceComponent: "stacks",
    numSuggestions: 0,
  });

// Remove illegal characters from the stack name during creation or edit
export const sanitizedStackName = (stackName: string): string => {
  return toValidFileName(stackName);
};
